/** auth-api rate-limit window limit (15 min) — the longest cooldown we ever honour. */
const MAX_COOLDOWN_SECONDS = 900;
/** Cooldown applied on a 429 that carries no readable `Retry-After` header. */
export const DEFAULT_RATE_LIMIT_COOLDOWN_SECONDS = 60;

/**
 * Parse a `Retry-After` header into a cooldown in seconds, clamped to [1, 900].
 *
 * auth-api emits `Retry-After` as integer delta-seconds (never the HTTP-date form),
 * so a non-numeric value yields `null` and the caller falls back to the default.
 * The header lookup is lowercase-only because axios lowercases response header keys.
 */
export function parseRetryAfter(headers?: Record<string, unknown>): number | null {
  const raw = headers?.['retry-after'];
  if (raw === undefined || raw === null) return null;
  const secs = Number(raw);
  if (!Number.isFinite(secs)) return null;
  return Math.min(MAX_COOLDOWN_SECONDS, Math.max(1, Math.floor(secs)));
}
